<!--
 * @Author: pyx 3245266940@qq.com
 * @Date: 2023-04-12 14:20:05
 * @LastEditors: pyx 3245266940@qq.com
 * @LastEditTime: 2023-04-17 13:47:30
 * @FilePath: \org-wx-front\src\views\Mine\mineDiscount.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="pageWrap">
        <div 
            class="flexRow discountItemBox" 
            :class="[(item.status == 1 || item.status == 4) ? 'normal' : 'grey']"
            v-for="(item,index) in discountList" 
            :key="index"
        >
            <div class="discountPriceBgc">
                <img src="../../assets/static/mine/discountPriceBgc.svg" alt="" class="discountPriceBgc">
                <div class="discountPriceBox colJcAc">
                    <div class="priceValue"><span class="symbol">￥</span>{{item.amount}}</div>
                    <div class="priceTips">无门槛</div>
                </div>
            </div>
            <div class="">
                <div class="discountType">{{item.name}}</div>
                <div class="discountDate">{{item.startTime}}-{{item.endTime}}</div>
            </div>
            <img src="../../assets/static/mine/discountStatus1.svg" alt="" class="discountStatusImg" v-if="item.status == 1">
            <img src="../../assets/static/mine/discountStatus2.svg" alt="" class="discountStatusImg" v-if="item.status == 2">
            <img src="../../assets/static/mine/discountStatus3.svg" alt="" class="discountStatusImg" v-if="item.status == 4">
            <img src="../../assets/static/mine/discountStatus4.svg" alt="" class="discountStatusImg" v-if="item.status == 3">
        </div>
    </div>
</template>
<script>
import {getDiscountCouponListAPI} from '../../utils/api/api'
export default {
    data() {
        return {
            // 状态（1.待使用 2.已使用 3.即将过期 4.已过期）
            discountList: [
                // {
                //     "id": "1096439448201203712",
                //     "code": "FR69C2W9KBV7",
                //     "name": "",
                //     "amount": "200.00",
                //     "startTime": "2023-04-14",
                //     "endTime": "2023-04-28",
                //     "status": 1
                // },
                // {
                //     "id": "1096439448201203712",
                //     "code": "FR69C2W9KBV7",
                //     "name": "",
                //     "amount": "200.00",
                //     "startTime": "2023-04-14",
                //     "endTime": "2023-04-28",
                //     "status": 2
                // },
                // {
                //     "id": "1096439448201203712",
                //     "code": "FR69C2W9KBV7",
                //     "name": "",
                //     "amount": "200.00",
                //     "startTime": "2023-04-14",
                //     "endTime": "2023-04-28",
                //     "status": 3
                // },
                // {
                //     "id": "1096439448201203712",
                //     "code": "FR69C2W9KBV7",
                //     "name": "",
                //     "amount": "200.00",
                //     "startTime": "2023-04-14",
                //     "endTime": "2023-04-28",
                //     "status": 4
                // },
            ]
        }
    },
    created() {
        this.getDiscountCouponList()
    },
    methods: {
        getDiscountCouponList() {
            getDiscountCouponListAPI().then(res => {
                if(res.resultCode == 200) {
                    this.discountList = res.data
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.pageWrap {
    height: 100%;
    background-color: #F4F7FA;
    padding: 0 .12rem;
    overflow: auto;
}
.discountPriceBgc {
    position: relative;
    width: 1.14rem;
    height: .98rem;
}
.discountPriceBox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.discountItemBox {
    border-radius: .12rem;
    margin-top: .16rem;
    height: .98rem;
    overflow: hidden;
    position: relative;
}
.priceValue {
    font-size: .32rem;
    font-weight: 500;
    line-height: .32rem;
    color: #ffffff;
}
.priceTips {
    font-size: .12rem;
    line-height: .18rem;
    color: #ffffff;
    margin-top: 2px;
}
.discountType {
    margin-left: .2rem;
    padding-top: .28rem;
    font-size: .15rem;
    color: #191C27;
}
.discountDate {
    margin-left: .2rem;
    font-size: .12rem;
    color: #9EA5BB;
    margin-top: 4px;
}
.symbol {
    font-size: .12rem;
    line-height: .18rem;
}
.discountStatusImg {
    width: .52rem;
    height: .42rem;
    position: absolute;
    top: 0;
    right: 0;
}
.normal {
    background: linear-gradient(270deg, #FFF3EB 0%, #FFF9F5 100%);
}
.grey {
    background-color: #ffffff;
    .discountType {
        color: #5A6073;
    }
}
</style>